import React, { Fragment } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Modal, Header, Button, Icon } from 'semantic-ui-react';

import * as ProductionReportSetupActions from '../state/reports/actions';
import * as ProductionReportSetupSelectors from '../state/selectors';
import { Pages, AllMealTypes, MealTypes } from '../helpers/Constants';
import { withReportSubscription } from 'State/report/withReportSubscription';
import { CreateProductionReportModalForm } from './CreateProductionReportModalForm';

class CreateProductionReportModal extends React.Component {
    isDisabled = (values) => {
        const { otherDetails, selectedMealTypes } = this.props; 
        if(_.includes(selectedMealTypes, MealTypes.Other)) {
            return otherDetails.length === 0;
        }
        else {
            var re = new RegExp(values.join('|'));
            return !re.test(selectedMealTypes);
        }
    }

    renderTitle() {
        const { page } = this.props;

        return (
            <Fragment>
                {page === Pages.SelectTemplate && 'Select a template for your report'}
                {page === Pages.AssignMenuMealType && 'Below select all that apply for this report'}
            </Fragment>
        );
    }

    renderBackButton() {
        const { page } = this.props;

        return (
            <Fragment>
                {page === Pages.AssignMenuMealType && 
                    <Button inverted color="orange" size="big" className='left floated' onClick={this.onBackClick}>
                        Back
                    </Button>
                }
            </Fragment>
        );
    }

    renderActionButton() {
        const { page } = this.props;

        return (
            <Fragment>
                {page === Pages.SelectTemplate && 
                    <Button inverted color="orange" size="big" onClick={this.onActionClick}>
                        Next
                    </Button>
                }
                {page === Pages.AssignMenuMealType && 
                    <Button inverted color="orange" size="big" onClick={this.onActionClick} disabled={this.isDisabled(AllMealTypes)}>
                        Save &amp; Close
                    </Button>
                }
            </Fragment>
        );
    }

    onBackClick = () => {
        const { page, changePage } = this.props;
        switch(page) {
            case Pages.AssignMenuMealType:
                changePage(Pages.SelectTemplate);
                break;
            default:
                break;
        }
    }

    onActionClick = () => {
        const { page, changePage, onSaveAndClose } = this.props;        
        switch(page) {
            case Pages.SelectTemplate:
                changePage(Pages.AssignMenuMealType);
                break;
            case Pages.AssignMenuMealType:
                onSaveAndClose();
                break;
            default:
                break;
        }
    }

    render() {
        const {
            modalProps
        } = this.props;

        const { onClose } = modalProps;

        return (
            <Modal {...modalProps}>
                <Header content={this.renderTitle()}/>    
                <Icon name="close" onClick={onClose} />
                <Modal.Content>
                    <CreateProductionReportModalForm />
                </Modal.Content>
                <Modal.Actions>
                    {this.renderBackButton()}
                    {this.renderActionButton()}
                </Modal.Actions>
            </Modal>
          );   
    }
}

const mapStateToProps = state => ({
    page: ProductionReportSetupSelectors.getPage(state),
    selectedMealTypes: ProductionReportSetupSelectors.getMealTypes(state),
    otherDetails: ProductionReportSetupSelectors.getOtherDetails(state),
});
  
const mapDispatchToProps = {
    changePage: ProductionReportSetupActions.changePage,
};

CreateProductionReportModal = withReportSubscription(CreateProductionReportModal);

CreateProductionReportModal = connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateProductionReportModal);

export { CreateProductionReportModal };


// WEBPACK FOOTER //
// ./src/pages/productionreportsetup/subpages/CreateProductionReportModal.js